import { Injectable } from '@angular/core';
import { AsyncValidator, ValidationErrors, FormControl } from '@angular/forms';
import { Observable } from 'rxjs';
import { map, catchError } from 'rxjs/operators';
import { LLMConfigurationService } from 'src/core/services/llm/llm-configuration.service';

@Injectable({ providedIn: 'root' })
export class LLMConfigurationNameValidator implements AsyncValidator {
  id: number | null;

  constructor(private llmConfigurationService: LLMConfigurationService) {}

  validate(
    formControl: FormControl
  ): Promise<ValidationErrors | null> | Observable<ValidationErrors | null> {
    const name = formControl.value;
    const id = this.id == null ? 0 : this.id;

    return this.llmConfigurationService.isNameAvailable(id, name).pipe(
      map(
        available => {
          return !available ? { llmConfigurationNameAlreadyInUse: true } : null;
        },
        catchError(() => {
          return null;
        })
      )
    );
  }
}
